import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ResourceAllocationAccessService } from '../components/project-management/resource-allocation-access.service';
import { environment } from '../../environment/environment';
import { PROJECT_DETAILS_TAB_KEYS } from '../components/project-management/project-details-tab.config';

/**
 * Blocks Documents / Project Feedback / Directory / Additional Notes / Insights
 * when the user lacks Resource Allocation (module 13) view for that tab.
 * Does not affect any other project-management child routes.
 */
export const resourceAllocationTabGuard: CanActivateFn = (route) => {
  const access = inject(ResourceAllocationAccessService);
  const router = inject(Router);

  access.refresh();

  const path = route.routeConfig?.path ?? '';
  const tabKey = access.resolveGatedTabFromRoute(path);
  if (tabKey == null) {
    return true;
  }

  if (tabKey === PROJECT_DETAILS_TAB_KEYS.Insights && environment.enablePmInsightsTab !== true) {
    return router.createUrlTree(['/dashboard', 'project-management', 'summary']);
  }

  if (access.canViewTab(tabKey)) {
    return true;
  }

  return router.createUrlTree(['/dashboard', 'project-management', 'summary']);
};
